export const home_safety = {
  environment: [
    {
      id: 1,
      index: 1,
      description: "Safe and adequate food and water supplies",
    },
    {
      id: 2,
      index: 2,
      description: "Stove and means for refrigerator present",
    },
    {
      id: 3,
      index: 3,
      description: "Adequate heat and ventilation",
    },
    {
      id: 4,
      index: 4,
      description: "Free from infestation",
    },
    {
      id: 5,
      index: 5,
      description:
        "Pathways free of obstacles such as loose rugs, furniture, etc.",
    },
    {
      id: 6,
      index: 6,
      description: "Clean area exists in which to store medical supplies",
    },
    {
      id: 7,
      index: 7,
      description: "Is cautious with heating pads",
    },
    {
      id: 8,
      index: 8,
      description: "Has a working smoke detector",
    },
    {
      id: 9,
      index: 9,
      description: "If uses oxygen, appropriate signs posted",
    },
  ],
  fireElectrical: [
    {
      id: 1,
      index: 10,
      description: "Fire exists available;warning devices installed",
    },
    {
      id: 2,
      index: 11,
      description:
        "No overuse of extension cords/adequate electrical outlets available",
    },
    {
      id: 3,
      index: 13,
      description: "Turns off oven and stove burners",
    },
    {
      id: 4,
      index: 14,
      description: "Emergency telephone numbers posted by phone",
    },
    {
      id: 5,
      index: 15,
      description: "Turns pot handles to back of stove",
    },
    {
      id: 6,
      index: 16,
      description: "Uses space heaters cautiously",
    },
    {
      id: 7,
      index: 17,
      description: "Does not smoke in bed",
    },
    {
      id: 8,
      index: 18,
      description: "Oxygen precautions used",
    },
  ],

  bathroomSafety: [
    {
      id: 1,
      index: 19,
      description: "No throws rugs",
    },
    {
      id: 2,
      index: 20,
      description: "Safety bars present and in good condition",
    },
    {
      id: 3,
      index: 21,
      description: "Lighting is adequate",
    },
    {
      id: 4,
      index: 22,
      description: "Shower chair is sturdy and in good working condition",
    },
  ],
  medicationUse: [
    {
      id: 1,
      index: 23,
      description: "Keeps all medications in original bottle or med box",
    },
    {
      id: 2,
      index: 24,
      description: "Has a medication schedule",
    },
    {
      id: 3,
      index: 25,
      description: "Home safety Instructions Given",
    },
  ],
};

export const cgpos = [
  {
    task: "Bathing",
    comment: "",
    yesNo: false,
  },
  {
    task: "Care of Teeth",
    comment: "",
    yesNo: false,
  },
  {
    task: "Care of skin",
    comment: "",
    yesNo: false,
  },
  {
    task: "Care of hair",
    comment: "",
    yesNo: false,
  },

  {
    task: "Dressing",
    comment: "",
    yesNo: false,
  },

  {
    task: "Meal Preparation",
    comment: "",
    yesNo: false,
  },

  {
    task: "Eating",
    comment: "",
    yesNo: false,
  },

  {
    task: "Toileting",
    comment: "",
    yesNo: false,
  },

  {
    task: "Transferring",
    comment: "",
    yesNo: false,
  },

  {
    task: "Ambulation",
    comment: "",
    yesNo: false,
  },

  {
    task: "Straightening Area",
    comment: "",
    yesNo: false,
  },

  {
    task: "Changing Bed",
    comment: "",
    yesNo: false,
  },

  {
    task: "Food Shopping",
    comment: "",
    yesNo: false,
  },

  {
    task: "Escort to Med Service",
    comment: "",
    yesNo: false,
  },

  {
    task: "Monitoring for safety",
    comment: "",
    yesNo: false,
  },

  {
    task: "Infection Control",
    comment: "",
    yesNo: false,
  },

  {
    task: "Light Housekeeping",
    comment: "",
    yesNo: false,
  },

  {
    task: "Medication*",
    comment: "",
    yesNo: false,
  },

  {
    task: "Other:",
    comment: "",
    yesNo: false,
  },
];

export const careGiverEvalList = [
  {
    evaluatedArea: "Bathing",
    satisfactory: false,
    comment: "",
  },
  {
    evaluatedArea: "Care of Teeth",
    satisfactory: false,
    comment: "",
  },
  {
    evaluatedArea: "Care of skin",
    satisfactory: false,
    comment: "",
  },
  {
    evaluatedArea: "Care of hair",
    satisfactory: false,
    comment: "",
  },
  { evaluatedArea: "Dressing", satisfactory: false, comment: "" },
  { evaluatedArea: "Meal Preparation", satisfactory: false, comment: "" },
  { evaluatedArea: "Eating ", satisfactory: false, comment: "" },
  { evaluatedArea: "Toileting", satisfactory: false, comment: "" },
  { evaluatedArea: "Transferring", satisfactory: false, comment: "" },

  {
    evaluatedArea: "Ambulation",
    satisfactory: false,
    comment: "",
  },
  {
    evaluatedArea: "Straightening Area",
    satisfactory: false,
    comment: "",
  },
  { evaluatedArea: "Changing Bed", satisfactory: false, comment: "" },
  { evaluatedArea: "Food shopping", satisfactory: false, comment: "" },
  { evaluatedArea: "Escort to Med Service ", satisfactory: false, comment: "" },
  { evaluatedArea: "Monitoring for safety", satisfactory: false, comment: "" },
  { evaluatedArea: "Infection Control", satisfactory: false, comment: "" },
  { evaluatedArea: "Light Housekeeping", satisfactory: false, comment: "" },
  { evaluatedArea: "Medication* ", satisfactory: false, comment: "" },
  { evaluatedArea: "Other: ", satisfactory: false, comment: "" },
];

export const participationReviewCG = [
  {
    events: "Recent Hospitalization",
    yesNo: false,
    comment: "",
  },
  {
    events: "Changes in Medical Condition",
    yesNo: false,
    comment: "",
  },
  {
    events: "Changes in Medication",
    yesNo: false,
    comment: "",
  },
  {
    events: "New Diagnoses",
    yesNo: false,
    comment: "",
  },
  {
    events: "Care Provided per Plan of Cafe",
    yesNo: false,
    comment: "",
  },
  {
    events: "Plan of care remains appropriate",
    yesNo: false,
    comment: "",
  },
  {
    events: "Participant Satisfaction",
    yesNo: false,
    comment: "",
  },
  {
    events: "Plan of Care Still meets Client’s needs.",
    yesNo: false,
    comment: "",
  },
];

export const competencyCheckList = [
  {
    subject: " Communication skills; Documentation and  record keeping",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "Keep a daily log; report  changes.",
  },

  {
    subject:
      "Observation, reporting  and documentation of  client status and the care or service  furnished",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "Physical; behaviors; ADL;  PCP visit; treatment plan.",
  },
  {
    subject: "Basic infection control  procedures",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList:
      "Handwash; personal hygiene; houseclean; apply  Covid-19 precautions",
  },
  {
    subject:
      "Basic elements of body  functioning and changes in body function that must be reported to an RN supervisor",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "As in item #2",
  },
  {
    subject: "Maintenance  ofclean,safe,and healthy environment",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "As in item #2",
  },
  {
    subject:
      "Recognizing emergencies and  knowledge of  emergency procedures  in the home",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "Post key emergency  contacts in home /tel.",
  },
  {
    subject:
      "The physical, emotional  and developmental needs  of and ways to work with  the populations served by  the agency including the  need for respect for the  client, his or her privacy  and his or her property",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList:
      " Practice client advocacy,  apply sensitive and safe care  behaviors ",
  },
  {
    subject: "Adequate nutrition and  fluid intake",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "Recommended diet.",
  },
  {
    subject: " Light housekeeping and  home managemen",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "As in item #3",
  },
  {
    subject: " Confidentiality ",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "As in item #7",
  },
  {
    subject: "Client control and  independent living philosophy",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "Autonomy; self-care activities",
  },
  {
    subject: " Activities of daily living",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "Care Plan",
  },
  {
    subject: " Preventing, recognizing and reporting  abuse, neglect",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "As in item #7",
  },
  {
    subject: " Deal with difficult behavior",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "As in item #7",
  },
  {
    subject:
      " Aide restrictions: Not taking money or gifts Not bringing family members  to the home. Not visiting the client outside  of work hours",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "As in item #7",
  },
  {
    subject:
      "Personal hygiene and  grooming, including: bed  bath; sponge, tub or shower  bath, shampoo--sink, tub, or  bed; nail and skin, hair care;  oral hygiene; toileting and  elimination",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "Care Plan",
  },
  {
    subject: " Safe transfer techniques  and ambulation",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "Care Plan",
  },
  {
    subject: " Meal planning and  preparation",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "Care Plan",
  },
  {
    subject: "  Shopping and errands ",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "Care Plan",
  },
  {
    subject: "Assist with self administered medication",
    evaluatedArea: "",
    satisfactory: false,
    comment: "",
    ratingList: "Care Plan",
  },
];

export const nursingAsessMedicalInfo = [
  {
    generalTopic: "Medical Conditions",
    subjectMatter: "",
    actionIndicated: "",
  },
  {
    generalTopic: "Medical Background",
    subjectMatter: "",
    actionIndicated: "",
  },
  {
    generalTopic: "Hospitalization Office Visits",
    subjectMatter: "",
    actionIndicated: "",
  },
];

export const systemAssessment = [
  {
    generalTopic: "Vital Signs",
    subjectMatter: [
      {
        temperature: "",
        pulse: ["Apical", "Radial", "Rt", "Lt", "Regular", "Irregular"],
        respirations: "",
        bp: ["Rt", "Lt", "Sitting", "Standing", "Lying"],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Neurological",
    subjectMatter: [
      {
        orientation: [
          "Alert",
          "Oriented (As reported)",
          "Disoriented",
          "Confused",
          "Forgetful: Often",
          "No verbal response ",
          "No response to pain",
          "Sedated but arousal",
          "Aphasic",
          "Dysphasic",
        ],
        pupils: ["Equal/Reacts to light"],
        other: "",
        grip: [
          "Strong bilaterally",
          "Weak",
          "Arm",
          "Rt",
          "Lt",
          "Leg",
          "Rt",
          "Lt",
        ],
      },
    ],

    actionIndicated: "",
  },
  {
    generalTopic: "Integumentary",
    subjectMatter: [
      {
        skin: [
          "Warm",
          "Cool",
          "Dry",
          "Clammy",
          "Turgor",
          "Pink",
          "Pale",
          "Other",
          "Rash",
          "Itching",
          "Bruising",
          "Incision",
          "Wound",
        ],
        oralMembranes: ["Pink", "Moist", "Dry/Cracked", "Mouth ulcers"],
      },
    ],

    actionIndicated: "",
  },
  {
    generalTopic: "Cardiovascular",
    subjectMatter: [
      {
        peripheral: [
          "WNL",
          "Sensation",
          "Paresthesia",
          " Capillary refill[>, < 3-5sec]",
          "Cyanosis",
        ],
        // sensation: "",
        // parenthesia: "",
        // capillary: "",
        // cyanosis: "",
        edema: [
          "None",
          "Pitting",
          "1+",
          "2+",
          "3+",
          "Non Pitting",
          "Chest pain",
          "AV shunt",
          "Bruit",
          "Thrill",
        ],
        locationEdema: "",
      },
    ],

    actionIndicated: "",
  },
  {
    generalTopic: "Respiratory",
    subjectMatter: [
      {
        respiratory: [
          "WNL",
          "Labored",
          "SOB",
          "Dyspnea while",
          "Sitting",
          "Exertion",
          "Wheezing",
          "Rhonchi",
          "Rales",
          "Productive cough",
          "color of sputum",
          "Non-productive cough",
          "Moist cough",
          "Dry cough",
        ],
        oxygen: "",
      },
    ],

    actionIndicated: "",
  },
  {
    generalTopic: "Musculoskeletal",
    subjectMatter: [
      {
        musculoskeletal: [
          "WNL",
          "Weakness: General weakness in the body",
          "Pain",
          "Stiffness",
          "Gait",
          "Steady",
          "Unsteady (Right lower extremity. Hx of older injury to right leg)",
          "Contractures",
          "Amputation",
        ],
      },
    ],

    actionIndicated: "",
  },
  {
    generalTopic: "Gastrointestinal",
    subjectMatter: [
      {
        abdomen: [
          "Soft",
          "Firm",
          "Distended",
          "Tender",
          "Bowels sounds",
          "Present all quads",
          "Absent",
          "Hyperactive",
          "Hypoactive",
          "Ostomy:",
          "Constipation",
          "Diarrhea",
          "Rectal Bleeding",
          "Incontinent of stool.",
          "Nausea",
          "Vomiting",
        ],
        pain: "",
        lastBM: "",
      },
    ],

    actionIndicated: "",
  },
  {
    generalTopic: "Genitourinary",
    subjectMatter: [
      {
        genitourinary: [
          "WNL",
          "Dysuria",
          "Pain",
          "Odor",
          "Incontinent",
          "Foley",
        ],
        size: "",
        color: "",
        LastChanged: "",
      },
    ],

    actionIndicated: "",
  },
  {
    generalTopic: "Pain",
    subjectMatter: [
      {
        pain: ["No pain", "Pain level (1-10):"],
        painLevel: "",
        location: "",
        onset: "",
        duration: "",
        painDescription: "",
        painRelief: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Medications",
    subjectMatter: "",
    actionIndicated: "",
  },
  {
    generalTopic: "Medication Allergies",
    subjectMatter: "",
    actionIndicated: "",
  },
  {
    generalTopic: "Current Treatments",
    subjectMatter: "",
    actionIndicated: "",
  },
  {
    generalTopic: "Current Therapy",
    subjectMatter: "",
    actionIndicated: "",
  },
  {
    generalTopic: "Dental Care",

    subjectMatter: [
      {
        dentalProblems: ["Yes", "No"],
        underCaredentist: ["Yes", "No"],
        dentalState: [
          "No Dentures",
          "Dentures Damaged",
          "Full Upper",
          "No Dentures",
          "Full Lower",
          "Not Wearing Dentures",
          "Partial Denture",
          "No Teeth",
        ],
        other: "",
        chewfood: ["Yes", "No"],
        dentistName: "",
        dentistPhone: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Vision",
    subjectMatter: [
      {
        vision: [
          "Unimpaired",
          "Adequate For Personal Safety",
          "Blind-Safe in Familiar locale",
          "Blind- Requires Assistance (since childhood)",
          "Distinguishes Only Light Or Dark ",
        ],
        wearGlasses: ["Yes", "No"],
        others: "",
      },
    ],
    actionIndicated: "",
  },

  {
    generalTopic: "Hearing",
    subjectMatter: [
      {
        hearing: [
          "Unimpaired",
          "Mild Impairment (Hard of hearing in both ears)",
          "Moderate Impairment but Not a Threat to Safety",
          " Impaired –Safety threat exists.",
          "Totally Deaf",
        ],
        useHearing: ["Right Ear", "Left Ear"],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Psychosocial",
    subjectMatter: [
      {
        pyschosocial: [
          "Cooperative",
          "Uncooperative",
          "Grieving",
          "Demanding",
          "Anxious",
          "Weeping",
          "Withdrawn",
        ],
        others: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Mental Health",
    subjectMatter: [
      {
        attitude: [
          "Cooperative",
          "Indifferent",
          "Resistive",
          "Demanding",
          "Suspicious",
        ],
        appearance: [
          "Well Groomed",
          "Adequate",
          "Disheveled",
          "Inappropriately Dressed",
          "Not Dressed",
        ],
        selfDirection: [
          "Independent",
          "Needs Motivation",
          "Dependent",
          "Needs Direction",
          "Hostile",
        ],
        behavior: [
          "Normal",
          "Wandering",
          "Sun downing",
          "Restless",
          "Hostile",
          "Withdrawn",
          "Self-Destructive",
          "Safety Hazard",
          "Verbal",
          "Physical",
        ],
        influence: [
          "Appropriate",
          "Inappropriate",
          "Anxious",
          "Blunted",
          "Euphoric",
          "Depressed",
          "Angry",
          "Mood Swings",
        ],
        thoughtContent: [
          "Normal",
          "Delusions",
          "Obsessions",
          "Phobias",
          "Persecutory",
          "Guilt",
          "Can’t Assess",
          "Aggressive",
        ],
        perceptions: [
          "Normal",
          "Hallucinations",
          "Auditory",
          "Visual",
          "Other",
        ],
        cognition: ["Normal", "Impairment", "Mild", "Moderate", "Severe"],
        insight: ["Good", "Partial", "None"],
        judgment: ["Good", "Adequate", "Poor"],
      },
    ],
    actionIndicated: "",
  },
];

export const dailyActivity = [
  {
    generalTopic: "Mobility Aids",
    subjectMatter: [
      {
        mobility: [
          "Uses Cane",
          "Uses Walker",
          "Uses Crutches",
          "Uses Grab Bars",
        ],
        wheelChair: ["Manual", "Electric"],
        others: "",
        comments: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Ambulation",
    subjectMatter: [
      {
        ambulation: [
          "Independent in Normal Environments",
          "Independent only in Specific Environment",
          "Requires Supervision",
          "Require Occasional or Minor Assistance",
          "Requires Significant or Continued Assistance",
        ],
      },
    ],
    actionIndicated: "",
  },

  {
    generalTopic: "Transferring",
    subjectMatter: [
      {
        independent: ["Independent"],
        supervisionTransferring: ["Bed", "Chair", "Toilet"],
        intermittentTransferring: ["Bed", "Chair", "Toilet"],
        continuedAssistance: [
          "Bed",
          "Chair",
          "Toilet",
          "Completely Dependent for All Movements",
        ],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Bathing",
    subjectMatter: [
      {
        bathing: [
          "Independent in Bathtub or Shower",
          "Independent with Mechanical Aids (E.g. bath seat)",
          "Requires Continued Assistance",
          "Resists Assistance",
        ],
        minorSupervision: [
          "Getting in and Out of Tub/Shower",
          "Turning Taps On and Off",
          "Washing Back",
        ],
        other: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Dressing",
    subjectMatter: [
      {
        independents: ["Independent"],
        supervision: ["Selecting Appropriate Clothing", "Coordinating Colors"],
        dailyHelp: [
          "Putting on Clothing",
          "Doing up Buttons, Laces, Zippers",
          "Pulling on Trousers, Socks, Shoes",
          "Determining Condition or Cleanliness of Clothing",
        ],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Grooming & Hygiene",
    subjectMatter: [
      {
        grooming: [
          "Independent",
          "Requires Reminder, Motivation&/or Direction",
          "Requires Total Assistance",
          " Resists Assistance",
        ],
        assistance: [
          "Putting Toothpaste of Toothbrush",
          " Using Electric Razor",
        ],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Eating",
    subjectMatter: [
      {
        eating: [
          "Independent",
          " Independent with Special Provision for Disability",
        ],
        intermittent: [
          "Cutting Up/Pureeing Food",
          "Must Be Fed",
          "Resists Feeding",
        ],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Bladder Control",
    subjectMatter: [
      {
        bladder: [
          "Totally Continent",
          "Needs Routine Toileting or Reminder",
          "Incontinent Due to Identifiable Factors",
          "Incontinent Once Per Day",
          "Incontinent More than Once per Day",
        ],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Bowel Control",
    subjectMatter: [
      {
        bowelControl: [
          "Has Total Control",
          "Needs Routine Toileting or Reminder",
          "No Bowel Control Due to Identifiable Factors",
          "Loses Bowel Control Once Per Day",
          "Loses Bowel Control More than Once per Day",
        ],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Toileting",
    subjectMatter: [
      {
        toileting: [
          "Requires Raised Toilet Seat or Commode",
          "Has Difficulty with Buttons, Zippers",
          "Needs Help with Aids (E.g. Catheter, Condom Drainage, etc.)",
        ],
        other: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Exercising",
    subjectMatter: [
      {
        exercisesRegularly: [
          "Daily",
          "Alternate Days",
          "Twice a Week",
          "Weekly",
        ],
        other: "",
        time: "",
        recentChangesToExercise: [
          "Exercise Alone",
          "Exercises with Attendant",
          "Other",
        ],
      },
    ],
    actionIndicated: "",
  },
];

export const livingHabit = [
  {
    generalTopic: "Smoking Habits",
    subjectMatter: [
      {
        clientSmoke: ["Yes", "No"],
        degreeOfProblem: ["No Problem", "Some Problem", "Major Problem"],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Alcohol Consumption",
    subjectMatter: [
      {
        clientDrink: ["Yes", "No"],
        degreeOfProblemAlcohol: ["No Problem", "Some Problem", "Major Problem"],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Current Diet",
    subjectMatter: [
      {
        currentDiet: [
          "Regular",
          "Soft",
          "Low Salt",
          "Low Fat",
          "Diabetic",
          "Vegetarian",
        ],
        other: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Allergies: Food & Other",
    subjectMatter: "",
    actionIndicated: "",
  },
  {
    generalTopic: "Eating Habits (appetite)",
    subjectMatter: [{ eating: ["Good", "Fair", "Poor"], comments: "" }],

    actionIndicated: "",
  },
];

export const instrumentalActivities = [
  {
    generalTopic: "Preparing Food",
    subjectMatter: [
      {
        prepareFood: [
          "Independent",
          "Adequate if Ingredients Supplied",
          "Can Make or Buy Meals but Diet is Inadequate",
          "Physically or Mentally Unable to Prepare Food",
          "No Opportunity to Prepare Food or Chooses ",
        ],
        notes: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Housekeeping",
    subjectMatter: [
      {
        housekeeping: [
          "Independent",
          "Generally Independent but Needs Help With Heavier Tasks",
          "Can Perform Only Light Tasks Adequately",
          "Performs Light Tasks but Not Adequately",
          "Needs Regular Help and/or Supervision",
          "No Opportunity to Do Housework or Chooses Not to Do Housework",
        ],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Shopping",
    subjectMatter: [
      {
        shopping: [
          "Independent",
          "Independent But For Small Items Only",
          "Can Shop if Accompanied",
          "Physically or Mentally Unable to Shop",
          "No Opportunity to Shop or Chooses Not to Shop",
        ],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Transportation",
    subjectMatter: [
      {
        transportation: [
          "Uses Private Vehicle",
          "Uses Taxi or Bus",
          "Independent",
          "Must be Accompanied",
          "Must be Driven",
          "Physically or Mentally Unable to Travel",
          "Needs Ambulance for Transporting",
        ],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Telephone",
    subjectMatter: [
      {
        telephone: [
          "Independent",
          "Can Dial Well Known Numbers",
          "Answers Telephone Only",
          "Physically or Mentally Unable to Use Telephone",
          "No Opportunity to Use Telephone or Chooses Not to Use Telephone",
        ],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Medication/Treatments",
    subjectMatter: [
      {
        medication: [
          "Completely Responsible for Self",
          "Requires Reminder or Assistance (Asreported)",
          "Responsible if Medications Prepared in Blister Pack",
          "Physically or Mentally Unable to Take Medications and Conduct Treatments",
          "Resists Taking Medication or Conducting Treatments",
        ],
      },
    ],
    actionIndicated: "",
  },
];

export const attendant = [
  {
    generalTopic: "Attendant",

    subjectMatter: [
      {
        attendant: ["Independent", "Needs an Attendant"],
        frequency: ["Intermittent", "Constantly", "During Day", "During Night"],
        attendantMeetBy: ["Spouse", "Friend", "Family"],
        others: "",
      },
    ],
    actionIndicated: "",
  },
];

export const socialProfile = [
  {
    generalTopic: "Housing",
    subjectMatter: [
      {
        housing: [
          "Self Owned House",
          "Apartment",
          "Rental",
          "Condominium",
          "Mobile Home",
          "Room",
          "Facility",
          "Urban",
          "Rural",
        ],
        others: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Living Companions",
    subjectMatter: [
      {
        livingCompanion: [
          "Lives Alone",
          "Lives with Spouse or Spousal Equivalent",
          "Lives With Adult Children",
          "Lives With Child(ren)",
          "Lives with Other Adult Male",
          "Lives with Other Adult Female",
        ],
        principalHelper: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Religion & Culture",
    subjectMatter: [
      {
        ethnicity: "",
        religion: "",
      },
    ],
    actionIndicated: "",
  },
];
export const communication = [
  {
    generalTopic: "Language Spoken",
    subjectMatter: [
      {
        spokenLanguage: [
          "English",
          "Italian",
          "French",
          "Spanish",
          "Chinese",
          "Russian",
          "Japanese",
          "East Indian",
        ],
        others: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Speech",
    subjectMatter: [
      {
        underStandableSpeech: [
          "Unimpaired",
          "Simple Phrases - Understandable",
          "Simple Phrases - Partially Understandable",
          "Isolated Words – Understandable",
          "Speech Not Understandable Or Does Not Make Sense",
          "Does Not Speak",
        ],
        clientSpeak: "",
        method: [
          "Effective",
          "Partially Effective",
          "Moderately Effective",
          "Not Effective",
        ],
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Understanding",
    subjectMatter: [
      {
        phrases: [
          "Unimpaired",
          "Understands Simple Phrases Only",
          "Understands Key Words Only",
          "Understanding Unknown",
          "Not Responsive",
        ],
      },
    ],
    actionIndicated: "",
  },
];

export const financialProfile = [
  {
    generalTopic: "Financial Benefits",
    subjectMatter: [
      {
        financialBenefits: [
          "Old Age Security Pension",
          "Guaranteed Income Supplement",
          "Gains for Senior",
          "War Veterans Allowance or Disability Pension",
          " Company Pension. ",
        ],
        others: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Financial Management",
    subjectMatter: [
      {
        financialMgmt: [
          "Self",
          "Spouse",
          "Family",
          "Friend",
          "Public Trustee",
          "Power of Attorney",
        ],
        others: "",
      },
    ],
    actionIndicated: "",
  },
  {
    generalTopic: "Financial Arrangements",
    subjectMatter: [{ approx: ["Appropriate", " Not Appropriate"] }],
    actionIndicated: "",
  },
];

export const additional = [
  {
    generalTopic: "",
    subjectMatter: "",
    actionIndicated: "",
  },
];
